import { InternationalStringDTO, TripDTO } from "../apiclient/ApiDtos";

export function getIntlStringValue(intString: InternationalStringDTO, lang: string) {
    return (lang == "en") ? intString.en : intString.my;
}

/**
 * //TODO
 * @param trip 
 * @param lang 
 * @returns 
 */
export function getBusTypeString(trip: TripDTO, lang: string): string {
    if (lang == 'my') {
        let stringMy = getIntlStringValue(trip.busType, lang);
        let stringEn = getIntlStringValue(trip.busType, "en");
        if(stringMy != stringEn) {
            let tokensOfStringEn: string[] = stringEn.split(/[ .:;?!~,`"&|()<>{}\[\]\r\n/\\]+/);
            //console.log("Tokens", tokensOfStringEn);
            let complementString = tokensOfStringEn
                .map(token => token.trim())
                .filter(token => !stringMy.toLocaleLowerCase().includes(token.toLocaleLowerCase()))
                .join(" ");
            if(complementString.trim().length > 0) {
                return `${stringMy} (${complementString})`;
            } else {
                return stringMy;
            }
        } else {
            return stringMy;
        }        
    } else {
        return getIntlStringValue(trip.busType, lang);
    }
}